// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__eRR8C","stuck":"Navigation_stuck__0HUoj","placeHolderShimmer":"Navigation_placeHolderShimmer__QbovB"};